import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

interface IFiscalPrecinctState {
  fiscalPrecinctDropdown: DropdownDTO[];
}

const initialState: IFiscalPrecinctState = {
  fiscalPrecinctDropdown: []
};

export const fiscalPrecinctSlice = createSlice({
  name: 'fiscalPrecinct',
  initialState,
  reducers: {
    loadingFiscalPrecinctDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.fiscalPrecinctDropdown = action.payload;
    },
  }
});

export const { loadingFiscalPrecinctDropdown } = fiscalPrecinctSlice.actions;
export default fiscalPrecinctSlice.reducer;
